import { Group, Switch as MantineSwitch, SwitchProps } from "@mantine/core"
import { forwardRef, ReactNode } from "react"

import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { buildLabel } from "../../../molecules/Inputs/utils"

import switchClassNames from "./Switch.module.css"

export interface CustomSwitchProps extends Omit<SwitchProps, "onChange"> {
  onChange?: (checked: boolean) => void
  label: string | ReactNode
  description?: string
  error?: string
  required?: boolean
  isLoading?: boolean
  inlineLabel?: boolean
  toolTip?: string
}

export const Switch = forwardRef<HTMLInputElement, CustomSwitchProps>(
  (
    {
      onChange,
      error,
      label,
      required,
      isLoading,
      inlineLabel,
      toolTip,
      ...props
    },
    ref
  ) => {
    const finalLabel = buildLabel({
      label,
      isLoading,
      required,
      toolTip,
    })

    const input = (
      <MantineSwitch
        ref={ref}
        classNames={switchClassNames}
        className={inlineLabel ? switchClassNames.inlineLabel : ""}
        label={inlineLabel ? undefined : finalLabel}
        onChange={(event) => onChange?.(event.currentTarget.checked)}
        error={error}
        h="var(--tfg-switch-height-sm)"
        {...props}
      />
    )

    return inlineLabel ? (
      <EqualWidthGrid>
        {finalLabel}
        <Group justify="end" w="100%">
          {input}
        </Group>
      </EqualWidthGrid>
    ) : (
      input
    )
  }
)

Switch.displayName = "Switch"
